import { getEnvVar, getEnvBoolean } from '@egr/xbox/utils/ReactScriptHelper';

export const ALLOW_CUSTOM_POOL: boolean = getEnvBoolean('ALLOW_CUSTOM_POOL', false);
export const GATEKEEPER_ID: string = getEnvVar('GATEKEEPER_ID', '');